/**
 * Created by A665445 on 13/04/2017.
 */
import {Component, OnInit} from '@angular/core';
import {EventManager} from 'ng-jhipster';
import {Account, Principal, LoginService} from '../shared';
import {StateStorageService} from '../shared/auth/state-storage.service';
import {Router} from '@angular/router';

@Component({
    selector: 'jhi-internal-connection',
    templateUrl: './internal.component.html'

})
export class InternalComponent implements OnInit {
    account: Account;

    email: string;
    password: string;
    rememberMe: boolean;
    authenticationError: boolean;

    constructor(
                private principal: Principal,
                private eventManager: EventManager,
                private router: Router,
                private loginService: LoginService,
                private stateStorageService: StateStorageService) {
    }

    ngOnInit() {
        /* this.principal.identity().then((account) => {
         this.account = account;
         }); */
        this.registerAuthenticationSuccess();
    }

    login(formValid: boolean) {
        if (formValid) {
            this.loginService.loginInternal({
                email: this.email,
                password: this.password,
                rememberMe: this.rememberMe
            }).then(() => {
                this.authenticationError = false;
                if (this.router.url === '/register' ||
                    this.router.url === '/finishReset' || this.router.url === '/requestReset') {
                    this.router.navigate(['/interne']);
                }

                this.eventManager.broadcast({
                    name: 'authenticationSuccess',
                    content: 'Sending Authentication Success'
                });

                // // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // // since login is succesful, go to stored previousState and clear previousState
                let previousState = this.stateStorageService.getPreviousState();
                if (previousState) {
                    this.stateStorageService.resetPreviousState();
                    this.router.navigate([previousState.name], {queryParams: previousState.params});
                }

                if (this.principal.hasSyncAuthority('ROLE_ADMIN') && this.principal.hasSyncAuthority('ROLE_MINISTRY')) {
                    this.router.navigate(['/saisines']);
                };

                if (this.principal.hasSyncAuthority('ROLE_ADMIN')) {
                    this.router.navigate(['/gestion-utilisateurs']);
                };

                if (this.principal.hasAnySyncAuthority(['ROLE_ACADEMICRECTOR', 'ROLE_ACADEMICREGIONRECTOR', 'ROLE_MINISTRY'])) {
                    this.router.navigate(['/saisines']);
                };

                if (this.principal.isSchoolProfile()) {
                    this.router.navigate(['/propositions']);
                };

            }).catch(() => {
                this.authenticationError = true;
            });
        }
    }

    registerAuthenticationSuccess() {
        this.eventManager.subscribe('authenticationSuccess', (message) => {
            this.principal.identity().then((account) => {
                this.account = account;
            });
        });
    }

    requestValidAccount() {
        this.router.navigate(['/reset', 'valid']);
    }
    requestResetPassword() {
        this.router.navigate(['/reset', 'request']);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/internal/internal.component.ts